module.exports = "mutation UpdateHotlineNumber($data:HotlineNumberInput!){updateHotlineNumber(data:$data){success}}"